import React, { Fragment } from 'react';
import times from 'lodash/times';
import { unescape } from 'lodash';

import Skeleton from 'ui/Skeleton';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const Title = ({ type }) => {
  if (type === 'role_play') {
    return (
      <>
        <strong>{t('lessons.editor.elements.role_play')} </strong>
        {t('lessons.editor.elements.role_play_feedback')}:
      </>
    );
  }

  let title = t('questions.title');

  if (type === 'scorm') {
    title = t('lessons.editor.elements.scorm');
  } else if (
    type === 'matching' ||
    type === 'sorting' ||
    type === 'knowledge_check'
  ) {
    title = t('lessons.editor.elements.knowledge_check');
  }

  return <strong>{title}:</strong>;
};

export const IncompleteSectionsSkeleton = () =>
  times(2, index => (
    <article key={index} className="missed_questions skeleton-loading">
      <header className="mb-24">
        <Skeleton wrapper="h3" width="66%" />
      </header>
      <Text className="mb-12" component="h4" variant={TEXT_VARIANTS.SUBHEADER}>
        <Skeleton width="40%" />
      </Text>
      <ul>
        {times(2, i => (
          <li key={i}>
            <Skeleton width="85%" />
          </li>
        ))}
      </ul>
    </article>
  ));

const IncompleteSections = ({ sections = [] }) => {
  if (sections.length < 1) {
    return null;
  }

  return sections.map(section => (
    <Fragment key={section.id}>
      <ul>
        {section.contents.map(content => (
          <li key={content.id}>
            <Title type={content.type} />{' '}
            {content.title && (
              <a href={content.htmlUrl}>{unescape(content.title)}</a>
            )}
          </li>
        ))}
      </ul>
    </Fragment>
  ));
};

export default IncompleteSections;
